const colors = { row: "#FFF", background: "#DEE2E6" };
const TableStyleCard = {
  table: {
    backgroundColor: colors.background, // Ensures white background
    border: "none", // Remove any borders
    borderRadius: "0",
  },
  header: {
    style: {
      padding: "0.75rem 1.25rem",
      backgroundColor: "#F8F9FA",
    },
  },
  headCells: {
    style: {
      fontSize: "1.2rem",
      color: "#ddd",
      verticalAlign: "bottom",
      backgroundColor: "#F8F9FC",
      borderBottom: "none", // Remove any border from head cells
    },
  },
  headRow: {
    style: {
      paddingTop: "16px",
      paddingBottom: "24px",
      backgroundColor: "#F8F9FC",
      borderBottomWidth: "0px",
      borderBottomColor: "blue",
    },
  },
  rows: {
    style: {
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
      "&:not(:last-of-type)": {
        borderBottomWidth: "0px",
        marginTop: ".5rem",
      },

      backgroundColor: colors.row,
      marginBottom: "1.5rem",
      borderRadius: "0.5rem",
    },
    stripedStyle: {
      backgroundColor: "rgb(251, 251, 251)", // Set striped row background
    },
  },
  cells: {
    style: {
      color: "#777",
      fontWeight: "400",
      lineHeight: "1.5",
    },
  },

  contextMenu: {
    style: {
      backgroundColor: colors.row,
      opacity: "0.8",
      borderRadius: "4px",
    },
  },
  pagination: {
    style: {
      background: "white",
      border: "none", // Remove pagination border
    },
  },
};
export default TableStyleCard;
